import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to develop a chatbot?",
    answer: `<p>The cost to develop a chatbot can vary on the complexity of chatbot solution you require. For
simple development, the cost can be anywhere between $500 and $10000 for a month. Most
software teams that provide chatbot app development services may charge $1000 and up to
$5000 for bots with greater functionality.</p>`,
  },
  {
    question: "What does a chatbot developer do?",
    answer: `<p>The job of a chatbot developer involves creating apps that automate tasks of customer support,
or simple, and repetitive communication processes. Chatbot engineers may design AI programs
that interact with human via audio, or text. They may create bots for a variety of unique
scenarios as suggested by the client.</p>`,
  },
  {
    question: "What is the difference between a bot and a chatbot?",
    answer: `<p>The primary difference between a bot and chatbot is that an AI chatbot uses Natural language
Understanding (NLU). It enables it to understand human language, tone, and expression as it is,
and generate appropriate responses in quick time.</p>`,
  },
  {
    question: "What are the 6 types of chatbots?",
    answer: `<p>Following are Six types of chatbots:</p>
    <ul>
    <li>Keyword-processing chatbots</li>
     <li>Menu-navigation chatbots</li>
      <li>Hybrid chatbots</li>
       <li>Intelligent chatbots</li>
        <li>Rule-based chatbots</li>
         <li>Speech-enabled chatbots</li>
  
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Chatbot Development Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
